<div class="z-fx z-fx-start-center z-fx-gap-8">
  @if (!isMultiSelect || (!selected && prefix)) {
    @if (prefix) {
      <div class="select-item-prefix z-fx-none">
        <ng-container [ngTemplateOutlet]="prefix" [ngTemplateOutletContext]="{ $implicit: value }"></ng-container>
      </div>
    }
  } @else {
    @if (!radioType) {
      <mat-checkbox
        [checked]="selected"
        class="zef-pointer-events-none no-margin"
        tabindex="-1"
        [disabled]="selected && disabled"
      ></mat-checkbox>
    }
    @if (radioType) {
      <mat-radio-button [checked]="selected" class="zef-pointer-events-none" tabindex="-1"></mat-radio-button>
    }
  }

  @if (label) {
    <div class="select-item-label zef-text-ellipsis z-fx-flex" [class.placeholder]="placeholder" textOverflow>
      <ng-container [ngTemplateOutlet]="label" [ngTemplateOutletContext]="{ $implicit: value }"></ng-container>
      @if (placeholder) {
        ...
      }
    </div>
  } @else {
    @if (!valuePrefixOnly) {
      <div class="select-item-label zef-text-ellipsis z-fx-flex" [class.placeholder]="placeholder" textOverflow>
        {{ value }}
      </div>
    }
  }
</div>
